import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
} from "@mui/material";

// Sample data including month and year
const dataProviders = [
  { name: "Active Providers", value: 400, month: "August", year: 2024 },
  { name: "Dormant Providers", value: 100, month: "August", year: 2024 },
  { name: "Active Providers", value: 380, month: "September", year: 2024 },
  { name: "Dormant Providers", value: 120, month: "September", year: 2024 },
  // Add more data for other months and years...
];

const TotalContentProviders = () => {
  // State for selected month and year
  const [selectedMonth, setSelectedMonth] = useState("August");
  const [selectedYear, setSelectedYear] = useState(2024);

  // Filter data based on selected month and year
  const filteredData = dataProviders.filter(
    (item) => item.month === selectedMonth && item.year === selectedYear
  );

  return (
    <Box>
      {/* Dropdown for selecting month */}
      <Stack direction={"row"} gap={3}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="month-select-label">Month</InputLabel>
          <Select
            labelId="month-select-label"
            value={selectedMonth}
            label="Month"
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            <MenuItem value="August">August</MenuItem>
            <MenuItem value="September">September</MenuItem>
            {/* Add more months as needed */}
          </Select>
        </FormControl>

        {/* Dropdown for selecting year */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="year-select-label">Year</InputLabel>
          <Select
            labelId="year-select-label"
            value={selectedYear}
            label="Year"
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <MenuItem value={2023}>2023</MenuItem>
            <MenuItem value={2024}>2024</MenuItem>
            {/* Add more years as needed */}
          </Select>
        </FormControl>
      </Stack>

      {/* Pie chart */}
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie dataKey="value" data={filteredData} outerRadius={80} label>
            {filteredData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index === 0 ? "#05a61d" : "#cc024c"} // Assign colors for active/dormant
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default TotalContentProviders;
